import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=09f24ebc&"
import script from "./Pager.vue?vue&type=script&lang=js&"
export * from "./Pager.vue?vue&type=script&lang=js&"
import style0 from "./Pager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pager.vue"
export default component.exports